module.exports = __webpack_public_path__ + "img/SL-M-160-180.138568e2.svg";